var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2129 5.57141C16.2129 5.1572 16.5487 4.82141 16.9629 4.82141H19.2857C20.6428 4.82141 21.75 5.92863 21.75 7.2857V11.1428C21.75 11.5571 21.4142 11.8928 21 11.8928C20.5858 11.8928 20.25 11.5571 20.25 11.1428V7.2857C20.25 6.75705 19.8144 6.32141 19.2857 6.32141H16.9629C16.5487 6.32141 16.2129 5.98562 16.2129 5.57141Z",
    fill: "#265EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.39307 7.2857C1.39307 5.92863 2.50028 4.82141 3.85735 4.82141H9.08592C9.50014 4.82141 9.83592 5.1572 9.83592 5.57141C9.83592 5.98562 9.50014 6.32141 9.08592 6.32141H3.85735C3.32871 6.32141 2.89307 6.75705 2.89307 7.2857V19.2857C2.89307 19.8143 3.32871 20.25 3.85735 20.25H19.2859C19.8146 20.25 20.2502 19.8143 20.2502 19.2857V15.4286C20.2502 15.0143 20.586 14.6786 21.0002 14.6786C21.4144 14.6786 21.7502 15.0143 21.7502 15.4286V19.2857C21.7502 20.6428 20.643 21.75 19.2859 21.75H3.85735C2.50028 21.75 1.39307 20.6428 1.39307 19.2857V7.2857Z",
    fill: "#265EA7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5757 3.4754L19.0713 7.62328C19.2848 7.97821 19.1702 8.43904 18.8153 8.65258C18.4604 8.86613 17.9995 8.75151 17.786 8.39659L15.2809 4.23293C15.0163 3.77597 14.4205 3.61724 13.9658 3.88047L13.9509 3.88892L5.24228 8.66745C4.87914 8.86671 4.42323 8.73386 4.22397 8.37072C4.02471 8.00759 4.15756 7.55168 4.5207 7.35242L13.2224 2.57766C14.3932 1.90573 15.8973 2.31103 16.5757 3.4754Z",
    fill: "#67C2E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.10742 8.14282C3.10742 7.72861 3.44321 7.39282 3.85742 7.39282H19.286C19.7002 7.39282 20.036 7.72861 20.036 8.14282C20.036 8.55704 19.7002 8.89282 19.286 8.89282H3.85742C3.44321 8.89282 3.10742 8.55704 3.10742 8.14282Z",
    fill: "#265EA7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2859 11.8928C18.5173 11.8928 17.8931 12.517 17.8931 13.2857C17.8931 14.0553 18.514 14.6785 19.2859 14.6785H21.1074V11.8928H19.2859ZM16.3931 13.2857C16.3931 11.6886 17.6889 10.3928 19.2859 10.3928H21.8574C22.2716 10.3928 22.6074 10.7286 22.6074 11.1428V15.4285C22.6074 15.8428 22.2716 16.1785 21.8574 16.1785H19.2859C17.6836 16.1785 16.3931 14.8818 16.3931 13.2857Z",
    fill: "#265EA7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.a06bcf14019d7e6f81c08f2cf6488c34.svg";
export { ForwardRef as ReactComponent };